import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-unattendedrequestpercentage-card',
  templateUrl: './helpbutton-reports-unattendedrequestpercentage-card.component.html',
  styleUrls: ['./helpbutton-reports-unattendedrequestpercentage-card.component.scss']
})
export class HelpbuttonReportsUnattendedrequestpercentageCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

  public getRoundedValue() {
    if (this.value) {
      return this.value.toFixed(2);
    } else {
      return 0;
    }
  }
}
